import { Component, OnInit } from '@angular/core';
import { EventosCompartidosService } from '@global-service/eventosCompartidos/eventosCompartidos.service';
import { NavegacionService } from '@global-service/navegacion/navegacion.service';
import { StorageService } from '@global-service/storage';
import { Observable, of } from 'rxjs';

@Component({ standalone: false, selector: 'app-clientes-backoffice-button',
  templateUrl: './clientes-backoffice-button.component.html',
})
export class ClientesBackOfficeButtonComponent implements OnInit{
  esAdmin = false;
  esSoporte = false;
  $enPaginaClientesBackOffice: Observable<boolean> = of(false);
  constructor(
    private readonly navegacionService: NavegacionService,
    private readonly eventosCompartidos: EventosCompartidosService,
    public readonly storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.esAdmin = this.storageService.getIsAdmin();
    this.esSoporte = this.storageService.getIsSoporte();
    this.$enPaginaClientesBackOffice = this.eventosCompartidos.$enPaginaClientesBackOffice();
  }
  onGoPaginaClientesBackOffice() {
    this.eventosCompartidos.setEnPaginaClientesBackOffice(false);
    this.navegacionService.navegar('BackOffice_GestionAltasClientes')
  }
  onGoDashboard() {
    this.navegacionService.navegar('dashboard');
  }
}
